import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer p-0">
      <h4>All rights reserved © ZKredit</h4>
    </div>
  );
}
